import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Modal} from 'shells/modal/modal';
import {OnboardingPage} from 'shells/onboarding-page/onboarding-page';

import {HelpBodyTasks} from './help-body-tasks';
import {HelpGraphicTasks} from './help-graphic-tasks';

type Props = {
    onClose: () => void;
    isOpen: boolean;
};

export class HelpTasks extends React.PureComponent<Props> {
    render() {
        return (
            <div>
                <Modal
                    isOpen={this.props.isOpen}
                    onClose={this.props.onClose}
                    noPadding={true}
                    closeButton={false}
                    preventBodyScroll={false}
                    maxHeight={500}
                >
                    <OnboardingPage
                        type='singlePage'
                        bodyComponent={<HelpBodyTasks />}
                        artBackgroundColor={colors.plumDk}
                        artImage={<HelpGraphicTasks />}
                        buttonText='Done'
                        onClose={this.props.onClose}
                    />
                </Modal>
            </div>
        );
    }
}
